@if (layout() === 'grid') {
  <div
    class="folder-card rounded-xl transition-shadow cursor-pointer"
    [class.folder-card--selected]="selected()"
    (click)="onClick()"
    (dblclick)="onDoubleClick()"
  >
    <p-card>
      <div class="flex items-center gap-3">
        <i class="fa-solid fa-folder text-2xl shrink-0" style="color: var(--color-monitoring)"></i>
        <div class="min-w-0 flex-1">
          <div class="font-semibold truncate">{{ stage().name }}</div>
          <div class="text-xs text-surface-500">
            {{ measurementCount() }} {{ 'stages.measurements' | translate }}
          </div>
        </div>
        @if (canEdit()) {
          <div class="shrink-0" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
            <cosmos-measurement-actions-menu [actions]="kebabActions()" [iconOnly]="true" />
          </div>
        }
      </div>
    </p-card>
  </div>
} @else {
  <div
    class="folder-row flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors hover:bg-surface-50 dark:hover:bg-surface-800 border-surface-200 dark:border-surface-700"
    [class.border-b]="!isLast()"
    [class.bg-primary-50]="selected()"
    [class.dark:bg-primary-950]="selected()"
    [class.rounded-t-xl]="selected() && isFirst()"
    [class.rounded-b-xl]="selected() && isAbsoluteLast()"
    (click)="onClick()"
    (dblclick)="onDoubleClick()"
  >
    <i class="fa-solid fa-folder shrink-0" style="color: var(--color-monitoring)"></i>
    <span class="flex-1 truncate font-medium">{{ stage().name }}</span>
    <span class="text-xs text-surface-500 shrink-0">
      {{ measurementCount() }} {{ 'stages.measurements' | translate }}
    </span>
    @if (canEdit()) {
      <div class="shrink-0" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
        <cosmos-measurement-actions-menu [actions]="kebabActions()" [iconOnly]="true" />
      </div>
    }
  </div>
}
